"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsChartSettingsAsPercentComponent = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const EventsPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsPageDataProvider");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const EventsChartSettingsAsPercentComponent = () => {
    const eventsPageDataContext = (0, EventsPageDataProvider_1.useEventsPageDataContext)();
    // const eventsPageModelContext = useEventsPageModelContext();
    const onAsPercentsRadioChange = (0, use_custom_compare_1.useCustomCompareCallback)((e) => {
        const isAsPercents = e.target.value === "asPercents";
        const chartSettingsJSONModel = eventsPageDataContext.stateFns.getURLJSONModel().getChartSettingsJSONModel();
        chartSettingsJSONModel.setAsPercents(isAsPercents);
        eventsPageDataContext.stateFns.onChartSettingsChanged(chartSettingsJSONModel.serialize());
    }, [eventsPageDataContext.urlState], lodash_1.default.isEqual);
    const { isError, inProgress, loaded } = eventsPageDataContext.state;
    const asPercentsIsOn = eventsPageDataContext.stateFns.getURLJSONModel().getChartSettingsJSONModel().isAsPercents();
    const disabled = inProgress || isError || !loaded || lodash_1.default.isNil(eventsPageDataContext.state.data);
    const radioValue = asPercentsIsOn ? "asPercents" : "classic";
    return React.createElement(antd_1.Radio.Group, { value: radioValue, size: "middle", disabled: disabled, optionType: "button", buttonStyle: "solid", onChange: onAsPercentsRadioChange },
        React.createElement(antd_1.Radio.Button, { value: "classic" },
            React.createElement(icons_1.LineChartOutlined, null)),
        React.createElement(antd_1.Radio.Button, { value: "asPercents" },
            React.createElement(icons_1.PercentageOutlined, null)));
};
exports.EventsChartSettingsAsPercentComponent = EventsChartSettingsAsPercentComponent;
